export default "__VITE_ASSET__B1e5f4Md__"